"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseEnvironmentCode = parseEnvironmentCode;
var _configurationManager = require("@ori/configuration-manager");
function parseEnvironmentCode(rawValue) {
  return _configurationManager.environmentsSchema.exclude(['dev']).parse(rawValue.toLowerCase());
}
